import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-report-help-modal',
  templateUrl: './report-help-modal.component.pug',
  styleUrls: ['./report-help-modal.component.scss'],
  standalone: false
})
export class ReportHelpModalComponent implements OnInit {
  constructor(
    public modalService: BsModalService,
  ) { 
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
